export default function ContextAdsResultsBlock() {
  const guarantees = [
    {
      number: '01',
      icon: 'ri-fire-line',
      title: 'Целевой трафик',
      text: 'Заинтересованные в вашем продукте люди, которые уже ищут его прямо сейчас — в поиске Google и Яндекс.',
    },
    {
      number: '02',
      icon: 'ri-bar-chart-grouped-line',
      title: 'Прозрачная сквозная аналитика',
      text: 'Вы будете видеть, куда уходит каждый рубль и откуда приходят клиенты. Никакого «чёрного ящика».',
    },
    {
      number: '03',
      icon: 'ri-settings-4-line',
      title: 'Постоянная оптимизация',
      text: 'Мы будем снижать цену цели (CPA) и увеличивать количество целевых обращений — непрерывно, неделя за неделей.',
    },
  ];

  return (
    <section id="context-ads-results" className="py-12 sm:py-24 bg-[#F9F5EF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1A2B4C]/08 border border-[#1A2B4C]/15 mb-5">
            <i className="ri-trophy-line text-[#C5A880] text-sm"></i>
            <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              Наши гарантии
            </span>
          </div>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight">
            Что вы получите в результате?
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto mb-6 rounded-full"></div>
          <div className="max-w-3xl mx-auto bg-white rounded-2xl border border-[#C5A880]/25 px-6 py-5 text-left">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-information-line text-[#C5A880] text-xl"></i>
              </div>
              <p className="text-sm sm:text-base text-[#1A2B4C]/75 leading-relaxed font-['Montserrat'] text-justify">
                В маркетинге нет гарантий точного количества продаж до старта — итоговый результат зависит
                от работы отдела продаж, конкурентоспособности цены, качества продукта и конверсии сайта.
                <strong className="text-[#1A2B4C]"> Мы честны с нашими клиентами.</strong>
              </p>
            </div>
          </div>
          <p className="text-sm sm:text-base text-[#1A2B4C]/80 font-semibold font-['Montserrat'] mt-5">
            Но мы гарантируем, что вы получите эти бизнес-показатели:
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 sm:gap-6 mb-10">
          {guarantees.map((item) => (
            <div
              key={item.number}
              className="bg-white rounded-2xl border border-[#C5A880]/20 p-6 sm:p-8 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#1A2B4C]/08 border border-[#1A2B4C]/10 flex-shrink-0">
                  <i className={`${item.icon} text-xl text-[#C5A880]`}></i>
                </div>
                <span className="text-[#C5A880] text-3xl font-['Playfair_Display'] font-bold opacity-40 select-none">
                  {item.number}
                </span>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-[#1A2B4C] font-['Playfair_Display'] mb-2 leading-snug">
                {item.title}
              </h3>
              <p className="text-sm text-[#1A2B4C]/65 leading-relaxed font-['Montserrat'] flex-1 text-justify">
                {item.text}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href="#context-ads-form"
            className="inline-flex items-center justify-center gap-2 bg-[#1A2B4C] hover:bg-[#253D6B] text-white w-full sm:w-auto px-7 py-4 rounded-xl font-semibold text-sm font-['Montserrat'] transition-all duration-300 hover:scale-[1.02] cursor-pointer leading-snug sm:whitespace-nowrap"
          >
            <i className="ri-calculator-line flex-shrink-0"></i>
            Получить расчёт стоимости лида для моего бизнеса
          </a>
        </div>
      </div>
    </section>
  );
}
